import { get, patch, post, put } from 'src/helpers/api'
import { api } from '../api'
import * as T from 'src/store/types'

export const getEsacPointsBalance = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.esacPointsBalance, query).then(response => {
      commit(T.SET_ESAC_POINTS_BALANCE, response.data.balance)
      resolve(response.data.balance)
    })
  })
}

export const getEsacPointsOrderListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.esacPointsRedemption, query).then(response => {
      const json = response.data.data
      commit(T.SET_ESAC_POINTS_REDEMPTION_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const getEsacPointsRedemptionByIdAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.esacPointsRedemptionOrderDetail, query).then(response => {
      const json = response.data
      json.total_point = json.points
      if (!json.product) {
        json.product = []
      }
      let productList = json.product.concat(json.kitting)
      productList.map(item => {
        item.price = item.gmp_price_gst
      })
      json.selected = {
        shipping: JSON.parse(json.shipping),
        campaign_selection: productList,
      }
      json.transaction_date = json.created_at
      json.order_fees = {
        total_nmp: json.total_npm,
        admin_fee: json.admin_fee || 0,
        delivery_fee: json.total_delivery_fee || 0,
        other_fee: json.other_fee || 0,
        tax_amount: json.total_tax || 0,
        total_gmp: json.points,
        rounding_adjustment: json.rounding_adjustment || 0,
      }
      json.invoice = {
        invoice_number: json.order_number,
        invoice_id: json.order_number,
        id: json.order_number,
      }
      json.order_status = 'Completed'
      commit(T.SET_ESAC_POINTS_REDEMPTION_DATA, {
        data: json,
      })
      resolve(json)
    })
  })
}

export const postEsacPointsRedemptionAction = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    post(api.esacPointsRedemption, payload)
      .then(response => {
        const json = response.data.data
        commit(T.SET_ESAC_POINTS_REDEMPTION_DATA, {
          data: json,
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getEsacPointVouchersListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.esacPointVouchers, query).then(response => {
      const json = response.data.data
      commit(T.SET_ESAC_POINTS_VOUCHER_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const getEsacPointsVoucherData = async ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.esacPointVouchers + '/' + id).then(response => {
      const json = response.data
      commit(T.SET_ESAC_POINTS_VOUCHER_DATA, json)
      resolve(json)
    })
  })
}

export const createEsacPointVoucherAction = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    post(api.esacPointVouchers, payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const updateEsacPointVoucherAction = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    const payload = {
      status_id: query.status_id,
      remarks: query.remarks,
    }
    patch(api.esacPointVouchers + '/' + query.id, payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getITokenAccumulateListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.iTokenAccumulateCalculation + query).then(response => {
      const json = response.data.data
      commit(T.SET_ITOKEN_ACCUMULATE_CALCULATION_LIST, {
        list: {
          data: json,
          total: response.data.total,
        },
      })
      resolve(response.data)
    })
  })
}

export const getEsacPointProductList = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    let priceRange = payload.priceRange || []
    let cvRange = payload.cvRange || []
    let pagination = payload.pagination

    let productPayload = {
      name: payload.name,
      country_id: payload.countryId,
      location_id: payload.locationId,
      categories: payload.categoryIds,
      sales_types: payload.salesTypesIds,
      sortby: payload.sortOrder,
      is_ek_smart: payload.ek_smart,
      is_rp: payload.is_rp || false,
      limit: pagination.limit,
      offset: pagination.offset,
      filters: payload.filters,
      cv_min: cvRange[0],
      cv_max: cvRange[1],
      price_min: priceRange[0],
      price_max: priceRange[1],
      has_epp: false,
      has_dummy: false,
    }

    post(api.esacPointsProduct, productPayload)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getEsacPointsCalculate = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    payload = {
      items: payload.selectedProducts.map(item => ({
        id: item.id,
        product_id: item.product_id,
        kitting_id: item.kitting_id,
        type: item.kitting_id !== null ? 'kitting' : 'product',
        quantity: item.quantity,
      })),
      address: payload.address,
      country_id: payload.countryId,
      location_id: payload.locationId,
      shipping: payload.shipping,
      type: 1,
    }
    post(api.esacPointsRedemptionCalculate, payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const createEsacPointsRedemption = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    payload = {
      items: payload.selectedProducts.map(item => ({
        id: item.id,
        product_id: item.product_id,
        kitting_id: item.kitting_id,
        type: item.kitting_id !== null ? 'kitting' : 'product',
        quantity: item.quantity,
        point: item.price,
      })),
      shipping: payload.shipping,
      total_points: payload.total_points,
      country_id: payload.countryId,
      location_id: payload.locationId,
      stock_location_id: payload.stockLocationId,
      user_id: payload.userId,
      type: 2,
    }
    post(api.createEsacPointsRedemption, payload)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getEsacPointsPdfLink = async ({ commit }, id) => {
  return new Promise(resolve => {
    get(api.esacPointsPdfLink + '/' + id).then(response => {
      const json = response.data
      resolve(json)
    })
  })
}
